import styled from 'styled-components';

export const SCellNotification = styled.div`
  color: ${({ theme }) => theme.colors.notificationBarText}!important;
`;

export const SCellNotificationText = styled.div`
  color: ${({ theme }) => theme.colors.notificationBarText}!important;
  font-size: 10px !important;

  * {
    font-size: 10px !important;
    color: ${({ theme }) => theme.colors.notificationBarText}!important;
  }
`;
